module.exports = __webpack_public_path__ + "img/广元市市第一人民医院.331bfad0.png";